import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '../dispatch'
import {
  deleteReferencesWithBindingGroupId,
  deleteReferencesWithBindingId,
} from '../slice/referenceSlice'
import { deleteBinding, undoRange } from '../workbook'
import { popUndoStack, pushToRedoStack } from '../slice/undoSlice'
import { CutTag, OfficeSimpleEvent } from '../types'
import mittEmitter from '../utils/mitt'

const getUndoRibbonRequestInput = (enabled: boolean) => ({
  tabs: [
    {
      id: 'QuickCut',
      groups: [{ id: 'DeleteGroup', controls: [{ id: 'Undo', enabled }] }],
    },
  ],
})

const useUndo = () => {
  const stack = useAppSelector((state) => state.undo.undoStack)
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (stack.length) {
      Office.ribbon.requestUpdate(getUndoRibbonRequestInput(true))
    } else {
      Office.ribbon.requestUpdate(getUndoRibbonRequestInput(false))
    }
  }, [stack])

  useEffect(() => {
    const handler = async () => {
      if (!stack.length) return
      const item = stack.at(stack.length - 1)
      if (!item) return
      if (item.type === 'ADD') {
        deleteBinding(item.reference.bindingId)
          .then(async () => {
            if (item.reference.bindingGroupId) {
              await dispatch(
                deleteReferencesWithBindingGroupId(
                  item.reference.bindingGroupId
                )
              )
            } else {
              await dispatch(
                deleteReferencesWithBindingId(item.reference.bindingId)
              )
            }
          })
          .then(async () => {
            if (item.reference.tag !== CutTag.REDACT) await undoRange(item)
            dispatch(popUndoStack())
            dispatch(pushToRedoStack(item))
          })
          .catch((err) => console.error(err))
      }
    }
    mittEmitter.on(OfficeSimpleEvent.UNDO, handler)

    return () => {
      mittEmitter.off(OfficeSimpleEvent.UNDO, handler)
    }
  }, [stack, dispatch])
}

export default useUndo
